module.exports = __webpack_public_path__ + "prod/1.2.3/img/bank.b28b458c.svg";